import { CheckoutStrategyEnum } from '../models/checkout-strategy.enum';
import {
  BemobiShopCheckoutResponse,
  CheckoutExecuteParams,
  EskolareShopCheckoutResponse,
  ShopCheckoutResponse,
  ShopCheckoutResponseApi
} from '../models/shop-checkout-response.model';

const CHECKOUT_STRATEGY_VALUES = Object.values(CheckoutStrategyEnum);

function isCheckoutStrategy(value: string): value is CheckoutStrategyEnum {
  return CHECKOUT_STRATEGY_VALUES.includes(value as CheckoutStrategyEnum);
}

export function mapShopCheckoutResponse(
  data: ShopCheckoutResponseApi
): ShopCheckoutResponse {
  const strategy = data.CheckoutStrategy;

  if (!isCheckoutStrategy(strategy)) {
    throw new Error('Estrategia de checkout invalida.');
  }

  if (strategy === CheckoutStrategyEnum.Eskolare) {
    return {
      checkoutStrategy: CheckoutStrategyEnum.Eskolare,
      sessionToken: null,
      redirectUrl: data.RedirectUrl ?? ''
    } satisfies EskolareShopCheckoutResponse;
  }

  return {
    checkoutStrategy: CheckoutStrategyEnum.Bemobi,
    sessionToken: data.SessionToken ?? null,
    redirectUrl: null
  } satisfies BemobiShopCheckoutResponse;
}

export function toCheckoutExecuteParams(
  response: ShopCheckoutResponse
): CheckoutExecuteParams {
  return { response };
}
